import {DceComponent, DceHTMLElement} from "dce-engine";
import Dce from "dce-engine/lib/decorators/Dce";

interface CategoriesColumnsShowMoreProps {
}

@Dce("CategoriesColumnsShowMore")
export default class CategoriesColumnsShowMore extends DceComponent<CategoriesColumnsShowMoreProps> {
    private text: HTMLElement;
    constructor(elem: DceHTMLElement, props: CategoriesColumnsShowMoreProps) {
        super(elem, props);

        this.elem.addEventListener('click', e => {

            if(!this.elem.classList.contains('expanded')){
                //pokazanie elementów

                this.elem.closest("ul").querySelectorAll("li").forEach(li => {
                    if(li.style.display == 'none'){
                        li.classList.add('expanded');
                        li.style.display = null;
                    }
                });

                this.elem.classList.add('expanded');

                this.elem.innerText = this.elem.getAttribute('data-label-less');

            }else{

                this.elem.closest("ul").querySelectorAll("li.expanded").forEach(li => {
                    li.classList.remove('expanded');
                    (li as HTMLElement).style.display = 'none';
                });

                this.elem.classList.remove('expanded');

                this.elem.innerText = this.elem.getAttribute('data-label-more');
            }

        });

    }



}